import React from "react";

import { ThemeProvider } from "@mui/material/styles";

import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import "react-dropdown-tree-select/dist/styles.css";
import { Provider } from "react-redux";

import App from "./App";
import AxiosAuthController from "./AxiosAuthController/AxiosAuthController";
import appLoaderLogoUrl from "./components/shared/AppLoader/loaderLogoUrl";
import { store } from "./redux/app/store";
import theme from "./theme";

if (process.env.NODE_ENV === "production") {
    Sentry.init({
        dsn: "https://dc32a5cdcb61221cd358be4b3d174b4c@o1081558.ingest.us.sentry.io/4509400448630784",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        sendDefaultPii: true,
        _experiments: { enableLogs: true },
    });
}
if (typeof Image !== "undefined") {
    const preload = new Image();
    preload.src = appLoaderLogoUrl;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
AxiosAuthController();
root.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </Provider>,
);
